export const LOCATION_CURRENTLY_UNKNOWN_OPTION = "Location Currently Unknown"
const UNKNOWN_LOCATION_PLACEHOLDER_REGEX = /^unknown-location\+.+$/i

export function isUnknownLocationValue(value: string | null | undefined): boolean {
  const normalized = (value ?? "").trim()
  if (!normalized) return false
  if (normalized.toLowerCase() === LOCATION_CURRENTLY_UNKNOWN_OPTION.toLowerCase()) return true
  return UNKNOWN_LOCATION_PLACEHOLDER_REGEX.test(normalized)
}

export function getDisplayAddressValue(value: string | null | undefined): string {
  if (!value) return ""
  return isUnknownLocationValue(value) ? LOCATION_CURRENTLY_UNKNOWN_OPTION : value
}

export function buildUnknownLocationPlaceholder(fullName?: string): string {
  const safeName = (fullName || "homeowner")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 24) || "homeowner"
  return `unknown-location+${safeName}-${Date.now()}`
}

export function searchableAddressValue(value: string | null | undefined): string {
  const stored = (value ?? "").toLowerCase()
  if (!isUnknownLocationValue(value)) return stored
  return `${stored} ${LOCATION_CURRENTLY_UNKNOWN_OPTION.toLowerCase()}`
}
